import React from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import Container from '@mui/material/Container'
import Paper from '@mui/material/Paper'
import { Outlet } from 'react-router-dom'

const LoginLayout: React.FC = () => (
  <Container component="main" maxWidth="xs">
    <CssBaseline />
    <Paper
      variant={window.innerWidth > 600 ? 'elevation' : 'outlined'}
      sx={{
        marginTop: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: 5,
        border: 'none',
      }}
    >
      <img
        rel="prefetch"
        src="/images/teatersmedjan.svg"
        alt="teatersmedjan-logo"
        width="300"
        style={{
          marginBottom: '20px',
        }}
      />
      <Outlet />
    </Paper>
  </Container>
)

export default LoginLayout
